import { pendingbooking } from "src/assets/images";
import React, { useState, useEffect } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "src/components/ui/button";
import Footer from "src/components/Footer";
import Navbar from "src/components/Navbar";
import SimilarProducts from "src/components/ProductCategories/SimilarProducts";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getItems, getProductDetails, getWishlist, UpdateWishlist } from "src/api";
import { renderErrorMessage, renderSuccessMessage } from "src/assets/functions";
import { useParams } from "react-router-dom";

const Wishlist = () => {
    const [selectedProductId, setSelectedProductId] = useState(null);

    const { data: wishlist, refetch } = useQuery({
        queryKey: ["getWishlist"],
        queryFn: getWishlist,
    });
    console.log("wishlist", wishlist)



    const { data: productDetails } = useQuery({
        queryKey: ["getProductDetails", selectedProductId],
        queryFn: () => getProductDetails(selectedProductId),
        enabled: !!selectedProductId, // Prevents fetching on load
        refetchOnWindowFocus: false, // Prevents refetching on window focus
    });

    const { mutate } = useMutation(UpdateWishlist, {
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
            refetch();
        },
        onError: (error) => renderErrorMessage(error.message),
    });


    useEffect(() => {
        if (selectedProductId) {
            refetch();
        }
    }, [selectedProductId, refetch]);

    // Function to add item to cart (localStorage)
    const addToCart = (product) => {
        if (!product) return;

        let cart = JSON.parse(localStorage.getItem("cart")) || [];

        const existingItemIndex = cart.findIndex(item => item.id === product.id);

        if (existingItemIndex !== -1) {
            cart[existingItemIndex].quantity += 1;
        } else {
            cart.push({ ...product, quantity: 1 });
        }

        localStorage.setItem("cart", JSON.stringify(cart));

        // alert("Item added to cart!");
        renderSuccessMessage("Product Added to Cart");
    };



    return (
        <>
            <Navbar />
            <div className="container mx-auto py-10">
                <h1 className="text-2xl font-bold mb-6">Wishlist</h1>
                <div className="grid grid-cols-10 gap-4 p-4 rounded-md font-semibold pending-fatix-booking-div">
                    <div className="col-span-2 text-center">Product Image</div>
                    <div className="col-span-2 text-center">Design Number</div>
                    <div className="col-span-2 text-center">Material</div>
                    <div className="col-span-2 text-center">Action</div>
                    <div className="col-span-2 text-center">Remove Item</div>
                </div>

                {wishlist?.data.length > 0 ? (
                    wishlist.data.map((booking) => (
                        <div key={booking.itemId} className="grid grid-cols-10 items-center gap-4 p-4 border-b pending-fatix-booking-div">
                            {/* Product Image */}
                            <div className="col-span-2 flex flex-col items-center">
                                <img
                                    src={booking.item?.itemImages?.length > 0 ? booking.item.itemImages[0]?.url : pendingbooking}
                                    alt={booking.item?.design_number}
                                    className="w-[120px] h-[200px] rounded-md object-cover pending-fatix-booking-div-img"
                                />
                            </div>
                            {/* Design Number */}
                            <div className="col-span-2 text-center font-semibold mobile-margin-bottom">
                                {booking.item?.design_number}
                            </div>

                            {/* Material */}
                            <div className="col-span-2 text-center font-semibold mobile-margin-bottom">
                                {booking.item?.material?.name}
                            </div>

                            {/* Buy Now Button (Adds to Cart) */}
                            <div className="col-span-2 flex justify-center mobile-margin-bottom">
                                <div onClick={() => setSelectedProductId(booking?.item?.id)}>
                                    <button
                                        className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
                                        onClick={() => addToCart(productDetails?.data)}
                                    >
                                        Add to Cart
                                    </button>
                                </div>
                            </div>

                            {/* Remove from Wishlist */}
                            <div className="col-span-2 flex justify-center the-trash-value">
                                <Trash2
                                    className="cursor-pointer text-red-500"
                                    onClick={() => mutate({ itemId: booking.itemId })}
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-gray-500 mt-4">No items in your wishlist.</p>
                )}
            </div>

            {/* Continue Shopping & Checkout */}
            <div className="container checkout-all-items">
                <a className="" href="/shop">Continue Shopping</a>
                <a
                    className="checkout-now-button"
                    href="1"
                    onClick={(e) => {
                        e.preventDefault(); // Prevent default navigation

                        let cart = JSON.parse(localStorage.getItem("cart")) || [];

                        wishlist?.data.forEach((booking) => {
                            const product = booking.item;
                            if (!product) return;

                            const existingItem = cart.find((item) => item.id === product.id);

                            if (!existingItem) {
                                cart.push({ ...product, quantity: 1 });
                            }
                        });

                        localStorage.setItem("cart", JSON.stringify(cart));
                        renderSuccessMessage("All wishlist items added to Cart!");
                    }}
                >
                    Checkout all Items
                </a>

            </div>

            {/* Similar Products Section */}
            <div className="container">
                <h1 className="consider-header mb-[20px] mt-[70px] also-consider-header">Also Consider</h1>
                <SimilarProducts />
            </div>
            <Footer />
        </>
    );
};

export default Wishlist;
